export const isValidReason = (reason) => {
  if (reason.length < 1 || reason.length > 1000) return false;
  const specialCharRemoved = reason.replace(/[^\w]/gi, '');
  return specialCharRemoved.length > 0 ? true : false;
};

export const ScoringPanelIndividualConfig = [
  { item: 'partyName', label: 'Name' },
  { item: 'customerRiskScore', label: 'Customer Risk Score' },
  { item: 'riskScoreHistory' },
  { item: 'customer_id', label: 'ID' },
  { item: 'gender', label: 'Gender' },
  { item: 'age', label: 'Age' },
  { item: 'nationality', label: 'Nationality' },
  { item: 'segmentCode', label: 'Segment' },
  { item: 'customerOnboardDate', label: 'Customer Since' }
];

export const ScoringPanelCorporateConfig = [
  { item: 'partyName', label: 'Name' },
  { item: 'customerRiskScore', label: 'Customer Risk Score' },
  { item: 'riskScoreHistory' },
  { item: 'customer_id', label: 'ID' },
  { item: 'age', label: 'Age' },
  { item: 'segmentCode', label: 'Segment' },
  { item: 'typeOfBusiness', label: 'Nature of Business' },
  { item: 'customerOnboardDate', label: 'Customer Since' }
];
